import MediaAdapter from './base';

export default class Status extends MediaAdapter {
  namespace = 'media/v4';
  modelNamePlural = 'status';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('statuses', 'status')
      .toLowerCase();
  }
}
